
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { RoleDDLAPI } from '../../Helper/Redux/DDLSlice/DDLSlice'


export const RoleDDL = (props) => {
    const { RoleDDLID, setRoleDDLID, Flag, data, Language,UserID } = props

    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            // Language: Language.Label,
            M_UserID: UserID ? UserID : '0',
        }
        dispatch(RoleDDLAPI({ data }))
    }, [])

    const { DDLData } = useSelector(state => state.RoleDDLData)

    useEffect(() => {
        handleDDL()
    }, [DDLData])

    const handleDDL = () => {
        if (DDLData && DDLData.length > 0) {
            let list = DDLData.map((item, index) => ({
                value: item.valueID,
                label: item.valueParam,
            }))

            setRoleDDLID({
                DDL: list,
                ID: Flag == 'Update' ? data?.m_RoleID : 0,
                Label: Flag == 'Update' ? data?.roleName : "Select...",
            })
        }
        else {
            setRoleDDLID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <Select
                id='RoleID'
                classNamePrefix='am-select'
                isClearable={true}
                isSearchable
                maxMenuHeight={130}
                value={{ value: RoleDDLID.ID, label: RoleDDLID.Label }}
                onChange={(e) => {
                    e ?
                        setRoleDDLID({ ...RoleDDLID, ID: e.value, Label: e.label })
                        :
                        setRoleDDLID({ ...RoleDDLID, ID: 0, Label: "Select..." })

                }}
                options={RoleDDLID.DDL}
            />
        </div>
    )
}